import React from 'react';
import loadable from '@loadable/component';
import { Routes as DomRoutes, Route, Outlet } from 'react-router-dom';

import { PageLoader, Layout, SidebarLayout } from 'components';
import { ProtectedPublicContainer, ProtectedPrivateContainer, PublicContainer } from 'modules';

import { publicUrls } from 'constants/urls';

const { login, forgotPassword, newPassword, profile, users, accounts } = publicUrls;

const ProfilePage = loadable(() => import('../pages/ProfilePage'), {
  fallback: <PageLoader />,
});

const DashboardPage = loadable(() => import('../pages/DashboardPage'), {
  fallback: <PageLoader />,
});

const UsersPage = loadable(() => import('../pages/UsersPage'), {
  fallback: <PageLoader />,
});

const AccountsPage = loadable(() => import('../pages/AccountsPage'), {
  fallback: <PageLoader />,
});

const LoginPage = loadable(() => import('../pages/LoginPage'), {
  fallback: <PageLoader />,
});

const ForgotPasswordPage = loadable(() => import('../pages/ForgotPasswordPage'), {
  fallback: <PageLoader />,
});

const NewPasswordPage = loadable(() => import('../pages/NewPasswordPage'), {
  fallback: <PageLoader />,
});

const NotFoundPage = loadable(() => import('../pages/NotFoundPage'), {
  fallback: <PageLoader />,
});

function Routes() {
  return (
    <DomRoutes>
      <Route
        element={
          <ProtectedPrivateContainer>
            <SidebarLayout>
              <Layout>
                <Outlet />
              </Layout>
            </SidebarLayout>
          </ProtectedPrivateContainer>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path={profile} element={<ProfilePage />} />
        <Route path={users.main} element={<UsersPage />} />
        <Route path={accounts.main} element={<AccountsPage />} />
      </Route>

      <Route
        element={
          <ProtectedPublicContainer>
            <Layout showLogo>
              <Outlet />
            </Layout>
          </ProtectedPublicContainer>
        }
      >
        <Route path={login} element={<LoginPage />} />
        <Route path={forgotPassword} element={<ForgotPasswordPage />} />
        <Route path={newPassword} element={<NewPasswordPage />} />
      </Route>

      <Route
        element={
          <PublicContainer>
            <Layout showLogo>
              <Outlet />
            </Layout>
          </PublicContainer>
        }
      >
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </DomRoutes>
  );
}

export default Routes;
